import type {
    MaterializedEmailSequence as MaterializedEmailSequenceFragment,
    MaterializedEmailSequence_materializedEmailSequenceTemplateMessages as Message,
} from 'nutshell-graphql-types';

import type {Template} from '../templates/template-groups/types';

import type {EmailComposerFormSequenceState} from './types';

export function flattenTemplatesInSequence(
    sequence: // Making inexact type because we modify them
    MaterializedEmailSequenceFragment
): EmailComposerFormSequenceState {
    return {
        id: sequence.emailSequenceTemplate.id,
        name: sequence.emailSequenceTemplate.name,
        isShared: sequence.emailSequenceTemplate.isShared,
        creatorUserId: sequence.emailSequenceTemplate.creatorUser
            ? sequence.emailSequenceTemplate.creatorUser.id
            : null,
        emailTemplates: getEmailTemplatesFromMaterializedEmailSequenceTemplateMessages(
            sequence.materializedEmailSequenceTemplateMessages
        ),
        isMaterialized: true,
    };
}

export const getEmailTemplatesFromMaterializedEmailSequenceTemplateMessages = (
    materializedEmailSequenceTemplateMessages: Message[]
) => {
    return materializedEmailSequenceTemplateMessages.reduce<Record<string, any>>(
        (accum, message, index) => {
            accum[message.emailSequenceTemplateMessage.emailTemplate.id] = {
                position: index,
                id: message.emailSequenceTemplateMessage.emailTemplate.id,
                subject: message.materializedEmailTemplate.subject,
                body: message.materializedEmailTemplate.body,
                plaintextBody: message.materializedEmailTemplate.plaintextBody,
                missingFieldsMessage: message.materializedEmailTemplate.missingFieldsMessage,
                expectedSendTime: message.emailSequenceTemplateMessage.expectedSendTime,
                sendAsReply: message.emailSequenceTemplateMessage.sendAsReply,
                // The EmailSequenceCreate mutation has slightly different naming
                delay: message.emailSequenceTemplateMessage.sendDelay
                    ? {
                          timespan: message.emailSequenceTemplateMessage.sendDelay.delayTimespan,
                          unit: message.emailSequenceTemplateMessage.sendDelay.delayUnit,
                      }
                    : null,
            };

            return accum;
        },
        {}
    );
};

export function flattenUnmaterializedTemplatesInSequence(
    template: Template
): EmailComposerFormSequenceState {
    return {
        id: template.id,
        name: template.name,
        isShared: template.isShared,
        creatorUserId: template.creatorUser ? template.creatorUser.id : null,
        emailTemplates: template.emailSequenceTemplateMessages.reduce<Record<string, any>>(
            (accum, message, index) => {
                accum[message.emailTemplate.id] = {
                    id: message.emailTemplate.id,
                    position: index,
                };

                return accum;
            },
            {}
        ),
        isMaterialized: false,
    };
}
